export default "__VITE_ASSET__BECDYeWr__"